import { useState } from "react";
import { useSearchLocationsByZip } from "@api";

export function useZipSearch(initialValue = "") {
  const { searchByZip, loading } = useSearchLocationsByZip();

  const [zip, setZip] = useState(initialValue);
  const [zipError, setZipError] = useState<string | null>(null);
  const [results, setResults] = useState<any[] | null>(null);

  const onChange = (value: string) => {
    if (/^\d{0,5}$/.test(value)) {
      setZip(value);
      setZipError(null);
    }
  };

  const onSearch = async () => {
    const trimmed = zip.trim();
    if (!/^\d{5}$/.test(trimmed)) {
      setZipError("El ZIP debe tener exactamente 5 dígitos numéricos.");
      return;
    }
    setZipError(null);
    const res = await searchByZip(trimmed);
    if (res) {
      setResults(res);
    }
  };

  const onClear = () => {
    setZip("");
    setZipError(null);
    setResults(null);
  };

  return {
    zip,
    zipError,
    results,
    loading,
    onChange,
    onSearch,
    onClear,
  };
}
